module.exports = __webpack_public_path__ + "img/54c5ef350b7148bda79882f2026f5306-1440.8c0e95cf.jpg";